import React from 'react'
import { useTranslation } from 'react-i18next'
import { isBefore } from 'date-fns'
import Flex from 'typescript-styled-flex'
import NotificationFooter from '../NotificationFooter'
import { theme } from '../../../theme'
import Expander from '../Expander'
import NestedNotification from '../NestedNotification'

export default function(notification, markRead, size = 1) {
  const { t } = useTranslation()
  const read = notification.readAt && isBefore(notification.readAt, new Date())

  const conflicts = (
    <div
      style={{
        color: read ? 'unset' : theme.colors.palette.tangerine,
        fontSize: `${16 * size}px`,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
      }}
    >{`${t('BBO_930_conflicts')}: ${
      notification.details.conflictedCounter
    }`}</div>
  )
  const imports = (
    <NotificationFooter
      size={size}
      style={{
        paddingBottom: `${18 * size}px`,
        paddingLeft: `${70 * size}px`,
        paddingRight: `${18 * size}px`,
      }}
    >{`${t('BBO_930_imports')}: ${
      notification.details.counter
    }`}</NotificationFooter>
  )

  return notification.details.conflictedCounter ? (
    <>
      <Expander
        size={size}
        id={notification.id}
        label={
          <>
            {`${t('BBO_930_imports')}: ${notification.details.counter} / `}
            &nbsp;
            {conflicts}
          </>
        }
      >
        <Flex
          column={true}
          justifyCenter={true}
          alignCenter={true}
          style={{
            background: theme.colors.palette.pinkishGrey,
            padding: `${15 * size}px`,
            paddingBottom: `${7 * size}px`,
          }}
        >
          {notification.details.notifications.map((not, index) =>
            NestedNotification(
              not,
              index + 1,
              notification.createdAt,
              'Booking',
              size,
            ),
          )}
        </Flex>
      </Expander>
    </>
  ) : (
    <>
      {imports} {markRead()}
    </>
  )
}
